import React, { Component } from "react";
import Filter from "../Filter/Filter";
import Dialog from "../Dialog/Dialog";
import Connection from "../../classes/Connection";
import Pagination from "../Pagination/Pagination";
import withRouter from "../withRouter/withRouter";
import no_image_img from "../../no-image.png";
import "./Items.css";

class Items extends Component {
    constructor(props) {
        super(props);
        this.connection = new Connection();
        this.no_image = { url: no_image_img };

        this.request_data = this.request_data.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.on_page_change = this.on_page_change.bind(this);
        this.decode_URI = this.decode_URI.bind(this);
        this.generate_query = this.generate_query.bind(this);
        this.parse_query = this.parse_query.bind(this);
    }
    state = {
        items: null,
        count: 15,
        page: 0,
        filters: null,
        total: null,
        dialog: null,
    };
    submittedUrl = null;

    componentDidMount() {
        this.decode_URI();
    }

    componentDidUpdate() {
        this.submittedUrl !=
            decodeURIComponent(this.props.router.location.search) &&
            this.decode_URI();
    }

    on_page_change(page) {
        this.setState({ page }, () => {
            this.props.router.navigate("/items" + this.generate_query());
        });
    }

    parse_query(query) {
        let res = {};

        if (!query || typeof query != "string") return null;
        query = query.split("&");

        if (query.length < 1) return null;
        query[0] = query[0].replace("?", "");

        query.forEach((q) => {
            q = q.split("=");
            res[decodeURIComponent(q[0])] =
                q.length > 1 ? decodeURIComponent(q[1]) : "";
        });
        return res;
    }

    decode_URI() {
        console.log(1);
        this.submittedUrl = decodeURIComponent(
            this.props.router.location.search
        );

        let query = decodeURIComponent(this.props.router.location.search);
        query = this.parse_query(query) || {};
        let { page, count } = query;

        query && delete query.page;
        query && delete query.count;

        this.setState(
            {
                filters: query,
                page: parseInt(page) || 0,
                count: parseInt(count) || 15,
            },
            () => {
                this.request_data();
            }
        );
    }

    generate_query() {
        let { filters, page, count } = this.state;

        let query = filters || {};
        count && (query.count = count);
        page > -1 && (query.page = page);

        let queryKeys = query && Object.keys(query);
        return (
            "?" +
            queryKeys
                .filter((k) => {
                    return (
                        query[k] &&
                        (Array.isArray(query[k])
                            ? query[k].length > 0
                                ? k
                                : null
                            : k)
                    );
                })
                .map((k) => {
                    return (
                        k +
                        "=" +
                        (typeof query[k] === "string"
                            ? query[k]
                            : JSON.stringify(query[k]))
                    );
                })
                .join("&")
        );
    }

    request_data() {
        let { toast, connection } = this.props;
        let { filters, page, count } = this.state;

        connection
            .get_filtered_data("items", filters, null, count, null, page)
            .then((res) => {
                let { items, total, page } = res.data;

                this.setState({ items, total, page });
            })
            .catch((err) => {
                toast("خطا در دریافت سفارشات", " خطای : " + err, " danger");
            });
    }

    onFilterChange(filters) {
        this.setState({ filters }, () => {
            this.props.router.navigate("/items" + this.generate_query());
        });
    }

    deleteItem(item) {
        this.setState({
            dialog: (
                <Dialog
                    message={"آیا میخواهید این کالا را حذف کنید؟"}
                    actions={[
                        {
                            text: "بله",
                            callback: (e) => {
                                let { items } = this.state;
                                let index = items.findIndex((i) => {
                                    return i.id === item.id;
                                });
                                items.splice(index, 1);
                                this.setState({ items });
                                this.connection
                                    .deleteItem(item.id)
                                    .then((res) => {
                                        this.props.toast(
                                            "حذف کالا",
                                            "کالا با موفقییت حذف شد",
                                            " confirm"
                                        );
                                    })
                                    .catch((err) => {
                                        items.splice(index, 0, item);

                                        this.setState({ items });
                                        this.props.toast(
                                            "حذف کالا",
                                            "کالا حذف نشد : " + err,
                                            " danger"
                                        );
                                    });

                                this.setState({ dialog: null });
                            },
                            classes: "btn danger",
                        },
                        {
                            text: "خیر",
                            callback: (e) => {
                                this.setState({ dialog: null });
                            },
                            classes: "btn confirm",
                        },
                    ]}
                />
            ),
        });
    }

    render() {
        let { items, count, total, page, filters } = this.state;

        return (
            <div className='ItemsComponentContainer'>
                <Filter
                    filters={[
                        {
                            label: "موجودی تمام شده",
                            value: "soldOut",
                            default: filters && filters.soldOut,
                        },
                        {
                            label: "موجود در انبار",
                            value: "available",
                            default: filters && filters.available,
                        },
                        {
                            label: "دارای تخفیف",
                            value: "has_discount",
                            default: filters && filters.has_discount,
                        },
                    ]}
                    onFilterChange={this.onFilterChange}
                />
                {this.state.dialog}

                <div className='addNewItem'>
                    <a className='btn info' href='/items/new'>
                        اضافه کردن کالا
                        <i className='ri-add-line'></i>
                    </a>
                </div>
                <div
                    className={
                        "Items " + (items && items.length === 0 ? "empty" : "")
                    }
                >
                    {items && items.length > 0 ? (
                        items.map((i) => {
                            return (
                                <div className='item' key={i.id}>
                                    <div className='itemImage'>
                                        <img
                                            src={
                                                (
                                                    (i &&
                                                        i.medias &&
                                                        i.medias.find((img) => {
                                                            return (
                                                                img &&
                                                                img.type ==
                                                                    "image"
                                                            );
                                                        })) ||
                                                    this.no_image
                                                ).url
                                            }
                                        />
                                    </div>
                                    <div className='itemName'>{i.name}</div>
                                    <div className='itemAvailableAmount'>
                                        مقدار مانده
                                        <div>
                                            {i.colors &&
                                                i.colors
                                                    .map((c) => {
                                                        return c.available_amount;
                                                    })
                                                    .reduce((partialSum, a) => {
                                                        return (
                                                            parseFloat(
                                                                partialSum
                                                            ) + parseFloat(a)
                                                        );
                                                    }, 0)}
                                        </div>
                                        {i.unit}
                                    </div>
                                    <div className='actions'>
                                        <div className='showInMarket'>
                                            <a
                                                href={
                                                    "https://kharazienika.ir/item/" +
                                                    i.id
                                                }
                                            >
                                                <i className='ri-eye-fill text confirm'></i>
                                            </a>
                                        </div>
                                        <div className='edit'>
                                            <a href={"/items/" + i.id}>
                                                <i className='ri-edit-fill text warning'></i>
                                            </a>
                                        </div>
                                        <div
                                            className='delete'
                                            onClick={(e) => this.deleteItem(i)}
                                        >
                                            <i className='ri-delete-bin-7-fill text danger'></i>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className='noItem text danger'>
                            هیچ کالایی وجود ندارد.
                        </div>
                    )}
                </div>
                {total && page !== null && count && (
                    <Pagination
                        count={count}
                        page={page}
                        total={total}
                        on_page_change={(p) => this.on_page_change(p)}
                    />
                )}
            </div>
        );
    }
}

export default withRouter(Items);
